import { reactive } from 'vue';

export const criarGabineteDepartamento = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cddepartamento: 0,
        nmdepartamento: '',
        ativo: 'S',
        idlogin: 0,
        idusuario: 0
    });
};